// Module
var code = `<div class="svc-question__adorner">
  <div class="svc-question__content svc-question__content--in-popup">

    <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
    <!-- /ko -->

  </div>
</div>`;
// Exports
export default code;